import React from "react"
import types from "prop-types"
import { activityHubSubmissionPath } from "utils/routeHelpers"

const FormSubmissionLink = ({ formSubmissionSlug }) => (
  <a className="font-semibold text-blue-1200" target="_blank" href={activityHubSubmissionPath(formSubmissionSlug)} rel="noreferrer">submission {formSubmissionSlug}</a>
)

FormSubmissionLink.propTypes = {
  formSubmissionSlug: types.string.isRequired,
}

export default FormSubmissionLink
